package com.milta.feature.profile.data.remote.dto

import com.milta.feature.profile.domain.entity.ProfileEntity
import kotlinx.serialization.Serializable

@Serializable
data class ProfileResponse(
    val accountId: String,
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
    val language: String? = null,
    val roles: List<String> = emptyList(),
)

fun ProfileResponse.toDomain() = ProfileEntity(
    accountId = accountId,
    firstName = firstName,
    lastName = lastName,
    phoneNumber = phoneNumber,
    language = language,
    roles = roles,
)
